import styled from 'styled-components';

export const TermsCheckboxLabel = styled.label<{ $isHighlighted: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 12px;
  text-align: left;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition:
    background-color 0.3s ease,
    box-shadow 0.3s ease;

  ${({ $isHighlighted }) =>
    $isHighlighted &&
    `
    background-color: rgba(255, 0, 0, 0.1);
    box-shadow: 0 0 0 2px rgba(255, 0, 0, 0.5);
    animation: highlight-pulse 0.5s ease-in-out 3;
  `}

  @keyframes highlight-pulse {
    0%,
    100% {
      box-shadow: 0 0 0 2px rgba(255, 0, 0, 0.5);
    }
    50% {
      box-shadow: 0 0 0 4px rgba(255, 0, 0, 0.8);
    }
  }

  .terms-checkbox {
    --size: 20px;
    --checkbox-background: transparent;
    --checkbox-background-checked: rgba(128, 62, 255);
    --border-color: rgba(128, 62, 255);
    --border-color-checked: rgba(128, 62, 255);
    --checkmark-color: #fff;
    flex-shrink: 0;
    margin-top: 2px;
  }

  span {
    flex: 1;
  }

  a {
    color: rgba(128, 62, 255);
    text-decoration: underline;
  }
`;

export const SubscriptionManageHint = styled.p`
  margin: 8px 0 0 28px;
  font-size: 12px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.7);
`;
